/**
 * The day the calendar shows (1.24): a new event from the app's ＋ starts on it instead of
 * today. Set by the calendar page while it is open, cleared when it closes.
 */
let shown: string | undefined;
export const setAddDay = (day: string | undefined) => {
  shown = day;
};
export const addDay = () => shown;
